<template>
    <div>
        <div class="form-group">
            <AppSearchInput :value="searchString" @input="search($event.target.value)"/>
        </div>
        <div v-if="filteredBlockIncomingObjects.length === 0" class="text-muted">
            No incoming objects
        </div>
        <template v-else>
            <WorkflowObjectTree
                v-for="(workflowObject, idx) in filteredBlockIncomingObjects"
                :workflowObject="workflowObject"
                :key="idx"
                :searchString="searchString"
                @select="onPropSelect"
                class="mb-2"
                :withObjectSelect="true"
                @selectCategory="selectCategory"
                :selectedCategories="selectedCategories"/>
        </template>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import WorkflowObjectTree from './objects/WorkflowObjectTree'
import AppSearchInput from '../../../../components/shared/AppSearchInput'
import {ACTION_DATASTORE_OPERATION, WORKFLOW_OBJ_TYPE_GLOBAL_PROPERTIES} from '../../../../models/workflow'

export default {
    name: 'TabObjects',
    components: {AppSearchInput, WorkflowObjectTree},
    props: {
        block: {
            type: Object,
            required: true
        },
        searchString: {
            type: String,
            required: true
        },
        selectedCategories: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters([
            'getBlockIncomingObjects'
        ]),

        blockIncomingObjects() {
            return this.block
                ? _.cloneDeep(this.getBlockIncomingObjects(this.block.id))
                    .sort(a => WORKFLOW_OBJ_TYPE_GLOBAL_PROPERTIES === a.type ? -1 : 1)
                : []
        },

        filteredBlockIncomingObjects() {
            if (this.isDataStoreBlock) {
                return this.blockIncomingObjects.filter(b => b.id !== this.block.model.objectId)
            }
            return this.blockIncomingObjects
        },

        isDataStoreBlock() {
            return _.get(this.block, 'model.key') === ACTION_DATASTORE_OPERATION
        }
    },
    methods: {
        selectCategory(data) {
            this.$emit('selectCategory', data)
        },
        onPropSelect(data) {
            this.$emit('select', data)
        },

        search(v) {
            this.$emit('search', v)
        }
    }
}
</script>
